var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"switch",attrs:{"for":_vm.id}},[_c('input',{attrs:{"type":"checkbox","id":_vm.id},domProps:{"checked":_vm.value},on:{"input":function($event){return _vm.$emit('input',$event.target.checked)}}}),_c('span',{staticClass:"slider bar"})])
}
var staticRenderFns = []

export { render, staticRenderFns }